import { render, staticRenderFns } from "./client-legacy-bullhorn.vue?vue&type=template&id=032c7f52"
import script from "./client-legacy-bullhorn.vue?vue&type=script&lang=js"
export * from "./client-legacy-bullhorn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports